"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var getField_1 = __importStar(require("../../utils/getField"));
function PropertyList(_a) {
    var car = _a.car, fields = _a.fields, view = _a.view;
    var gridColView = view === 'col';
    var options = fields.reduce(function (acc, field) {
        var _a = getField_1.default(car, field), title = _a[0], value = _a[1];
        var resolvedValue = typeof field.render === 'function' ? field.render(value) : value;
        if (title && value) {
            if (gridColView) {
                acc.push(react_1.default.createElement("div", { key: field.id, className: "col-md-6 col-lg-4" },
                    react_1.default.createElement("div", { className: "row" },
                        react_1.default.createElement("div", { className: "col-7" },
                            title,
                            ":"),
                        react_1.default.createElement("div", { className: "col-5" }, resolvedValue))));
            }
            else {
                acc.push(react_1.default.createElement("tr", { key: field.id },
                    react_1.default.createElement("td", null,
                        title,
                        ":"),
                    react_1.default.createElement("td", null, resolvedValue)));
            }
        }
        return acc;
    }, []);
    if (!options.length)
        return null;
    return gridColView ? (react_1.default.createElement("div", { className: "row azgazui__property-list" }, options)) : (react_1.default.createElement("table", { className: "azgazui__property-list" },
        react_1.default.createElement("tbody", null, options)));
}
exports.default = PropertyList;
PropertyList.displayName = 'PropertyList';
PropertyList.propTypes = {
    car: prop_types_1.default.objectOf(prop_types_1.default.any).isRequired,
    fields: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        source: prop_types_1.default.PropTypes.oneOf(Object.keys(getField_1.SOURCES).map(function (key) { return getField_1.SOURCES[key]; })).isRequired,
        id: prop_types_1.default.string.isRequired,
        render: prop_types_1.default.func,
        title: prop_types_1.default.string,
    })).isRequired,
    view: prop_types_1.default.oneOf(['col', undefined]),
};
